<template>
  <div class="line-chart">
    <canvas :id="chartId"></canvas>
    <div :id="legendId" class="legend">
		<div
			class='legend-child'
			v-for="dataset in linechartdata.datasets"
			:key="dataset.label"	>
		<!--
			<span @click='legendClick($event)' class='legend-box' :style="{background: dataset.borderColor}"></span>
			<span @click='legendClick($event)' class='legend-text'>{{ dataset.label }}</span>
			<img
				:src="addPng"
				alt="add"
				:data-column="dataset.tesasColumn"
				@click="changeCol($event)" />
		-->
		</div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import Chart from "chart.js"
//import addPng from "../../assets/images/6-analysis/add.png"

export default {
  props: ["index","chartdata","chartcolumns","categ","subcateg","location","userColumnsData"],
  mounted () {
    this.ctx = document.getElementById(this.chartId);
    // 生成 Linechart並顯示
    this.myChart = new Chart(this.ctx, {
        type: 'line',
        data: this.linechartdata,
        options: this.options
    });
	//console.log(this.chartdata);
	//console.log(this.location.type)
	//console.log('this.myChart.id: '+this.myChart.id);
	//console.log('this.chartId: '+this.chartId)
	var thisChartId = this.subcateg.charts[Number(this.chartId.substring(6))]
	this.myChart.admnlvcmp = thisChartId.admnlvcmp
	//console.log('Compare admin. levels: '+ this.myChart.admnlvcmp)
	//console.log(this.myChart)
	if (this.myChart.admnlvcmp && this.location.type == 'town'){
		//console.log(this.myChart)
		var datasets = this.myChart.data.datasets;
		this.myChart.legendtexts = [];
		this.myChart.defaulthidden = [];
		this.myChart.defaultlegends = [];
		//console.log(datasets);
		for (let idset = 0; idset < datasets.length; idset++){
			var tesasColumn = datasets[idset].tesasColumn;
			this.myChart.legendtexts.push(datasets[idset].label);
			var meta = this.myChart.getDatasetMeta(idset);
			if(tesasColumn.substring(tesasColumn.length - 7) == '-county'||
			   tesasColumn.substring(tesasColumn.length - 7) == '-nation'){
				//console.log('County data.')
				//this.myChart.getDatasetMeta(idset).hidden = true;
				this.myChart.data.datasets[idset].label = '';
				meta.hidden = true;
				this.myChart.defaulthidden.push(true);
				this.myChart.defaultlegends.push('');
				this.myChart.update();
			}else{
				this.myChart.defaulthidden.push(false);
				this.myChart.defaultlegends.push(this.myChart.data.datasets[idset].label);
			}
		}
	}
  },
  data() {
    return {
      //colors: ["#f0027f", "#666666", "#bf5b17", "#386cb0", "#fa7f0c", ],
	  colors: ["#FB6107", "#51557E", "#5C8001", "#AA5656", "#918450", "#F2BE22", "#AE431E"],
	  colorsadmnlvcmp: 
	  ["#FB6007", "#FDBF9C", "#FC9051", "#51557E", "#B9BBCB", "#8588A5", "#5C8001", "#AEC080", "#8DA64D", "#AA5656", "#DDBBBB", "#C48989", "#918450", "#D3CEB9", "#B2A985", "#F2BE22", "#FAE5A7", "#F6D264", "#AE431E", "#DFB3A5", "#C67B62"],
	  userColors: ["#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7", "#DDA0DD", "#98D8C8", "#F7DC6F", "#BB8FCE", "#85C1E9"],
	  borderdash: [[],[],[10,5],[],[],[10,5],[],[],[10,5],[],[],[10,5],[],[],[10,5],[],[],[10,5],[],[],[10,5]],
      colorCounter: 0,
      //addPng,
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: true,
		  position: "bottom",
		  //customize the label to wipe off when no text is there.
		  //this enables the chart to hide specific legend label when the data line is hidden.
		  labels: {
		  	boxWidth: 5,
		  	generateLabels: function(chart) {
		  		const original = Chart.defaults.global.legend.labels.generateLabels;
		  		const labels = original(chart);
		  		
		  		labels.forEach(label => {
					//console.log(label)
					if (label.text === '') {
						label.lineCap = 'butt'; // Make the legend entry look empty
						label.fillStyle = 'transparent'; // Make the legend entry transparent
						label.lineWidth = 0; // Make the legend entry transparent
					}
		  		});
		  
		  		return labels;
		  	}
		  },
		  onClick: this.legendClick
        },
        legendCallback: this.legendCallback,
		onClick: this.lineClick
      },
	  ctx: null,
	  myChart: null,
	  colsel: null,
	  year: null,
	  seriesName: null
    }
  },
  methods: {
    colorChange(admnlvcmp) {
      this.colorCounter++;
	  var ncolors = admnlvcmp? this.colorsadmnlvcmp.length:this.colors.length;
      if(this.colorCounter == ncolors)
        this.colorCounter = 0
    },
	lineClick(e){
		//console.log(this.myChart);
		//console.log(e);
		var point = this.myChart.getElementAtEvent(e)[0];
		if (point){
			var seriesNumber = point._datasetIndex;
			var positionOnSeries = point._index;
			var dataValue = this.myChart.data.datasets[seriesNumber].data[positionOnSeries];
			var tesasColumn = this.myChart.data.datasets[seriesNumber].tesasColumn;
			//No action for data points on the nation time series or user data
			if (tesasColumn.substring(tesasColumn.length - 7) != '-nation' && 
				!tesasColumn.startsWith('user_')){  // Ignore user data clicks
				this.tesasColumn = tesasColumn
				var legendLabel = this.myChart.data.datasets[seriesNumber].label;
				if (tesasColumn.substring(tesasColumn.length - 7) == '-county'){
					this.seriesName = legendLabel.substring(0,legendLabel.lastIndexOf('-'));
					this.colsel = tesasColumn.substring(0,tesasColumn.lastIndexOf('-'));
				}else{
					this.seriesName = legendLabel;
					this.colsel = tesasColumn;
				}
				this.year = this.myChart.data.labels[positionOnSeries];
				//console.log('Series number '+seriesNumber+' = '+this.colsel+', position '+ positionOnSeries+' = Year '+this.year);
				//console.log(this.seriesName+'：'+dataValue);
				this.changeCol();
			}
		}
	},
	legendClick(e, legendItem) {
		var index = legendItem.datasetIndex;
		var ci = this.myChart;
		
		// Check if this is a user data series
		var tesasColumn = ci.data.datasets[index].tesasColumn;
		if (tesasColumn && tesasColumn.startsWith('user_')) {
			// For user data, do nothing - nullify the click
			return;
		}
		if (this.location.type != 'county' && this.chartdata.admnlvcmp){
			var index0 = index - (index % 3) // the index of the town series
			//console.log(index0)
			var meta0 = ci.getDatasetMeta(index0);
			var meta1 = ci.getDatasetMeta(index0+1);
			var meta2 = ci.getDatasetMeta(index0+2);
			var tesasColumn0 = ci.data.datasets[index0].tesasColumn;
			function resetchart(){
				for (let idset = 0; idset < ci.data.datasets.length; idset++){
					var meta_i = ci.getDatasetMeta(idset)
					var tesasColumn = ci.data.datasets[idset].tesasColumn;
					
					// Only modify original data, not user data
					if (!(tesasColumn && tesasColumn.startsWith('user_'))) {
						meta_i.hidden = ci.defaulthidden[idset];
						ci.data.datasets[idset].label = ci.defaultlegends[idset];
					}
				}
			}
			function showseries(sidx){
				//console.log(sidx);
				//console.log(ci.data.datasets.map(s=>s.borderColor));
				for (let idset = 0; idset < ci.data.datasets.length; idset++){
					var meta_i = ci.getDatasetMeta(idset)
					var tesasColumn = ci.data.datasets[idset].tesasColumn;
					
					// Only modify original data, not user data
					if (!(tesasColumn && tesasColumn.startsWith('user_'))) {
						if(!sidx.includes(idset)){
							// See https://github.com/chartjs/Chart.js/issues/4760 regarding disabling legend texts
							ci.data.datasets[idset].label = '';
							meta_i.hidden = true;
						}else{
							ci.data.datasets[idset].label = ci.legendtexts[idset]
							meta_i.hidden = null;
						}
					}
				}
			}
			if (meta1.hidden == true && meta2.hidden == true){
				//show town and county series
				showseries([index0,index0+1]);
			}else if(meta1.hidden != true && meta2.hidden == true){
				//show town and nation series
				showseries([index0,index0+2]);
			}else if(meta2.hidden != true){
				//return to the default multi-variable town series presentation
				resetchart();
			}
			//after setting needed parameters, render the updated chart.
			ci.update();
		}
	},
    runSerial(tasks) {
      var result = Promise.resolve();
      tasks.forEach(task => {
        result = result.then(() => task());
      });
      return result;
    },
    changeCol() {
	  //console.log(this.categ.id, this.subcateg.id, this.year, this.colsel);
	  var legendTitle = this.seriesName+'（'+this.year+'年）'
	  //console.log(legendTitle)
      let tasks = [
        () => { $('#legendtitle').val(legendTitle).change()},
        () => { $('#categ1').val(this.categ.id).change() },
        () => { $('#categ2').val(this.subcateg.id).change() },
        () => { $('#categ3').val(this.colsel).change()},
        () => { $('#year').val(this.year).change()},
		() => { 
				//console.log(this.myChart.admnlvcmp);
				//console.log(this.location);
				//console.log($("#town").val())
				//console.log(this.tesasColumn.substring(this.tesasColumn.length - 7));
				////make sure location id is not lost when switching bwtween county/town maps:
				////	when producing county map, town id could be nullified.
				//if ($("#town").val() != this.location.id){
				//	$("#town").val(this.location.id)
				//	//console.log($("#town").val());
				//}
				if ((this.myChart.admnlvcmp
					&& this.location.type == 'town'
					&& this.tesasColumn.substring(this.tesasColumn.length - 7) == '-county') ||
					  (this.location.type == 'county')){

					//console.log('Assigned zoom: county')
					//console.log(this.location.id)
					$('#zoom2county').click();

				}else{

					//console.log('Assigned zoom: town')
					//console.log(this.location.id)
					$('#zoom2town').click();

				}
			  },
 		() => { this.$root.$emit('retract_panel') }
      ]

      this.runSerial(tasks)
    }
  },
  computed: {
    chartId() {
      return "chart-" + this.index
    },
    legendId() {
      return "legend-" + this.index
    },
    linechartdata() {
	  //console.log(this.chartdata)
	  //console.log('adminscl from line-chart: '+ this.location.type)
      let data = _.cloneDeep(this.chartdata)

      // Add user columns if they exist
      if (this.userColumnsData && this.userColumnsData.length > 0) {
        this.userColumnsData.forEach((userCol) => {
          data.datasets.push({
            label: userCol.title,
            tesasColumn: 'user_' + userCol.title,
            data: userCol.data.map(val => parseFloat(val) || null)
          });
        });
      }
      data.datasets = data.datasets.map((d) => {
        // Check if this is a user-added dataset
        const isUserData = d.tesasColumn && d.tesasColumn.startsWith('user_');
		if (this.chartdata.admnlvcmp && this.location.type == 'town'){
			let val = Object.assign(d, {
				borderColor: isUserData ? this.userColors[this.colorCounter % this.userColors.length] : this.colorsadmnlvcmp[this.colorCounter],
				backgroundColor: isUserData ? this.userColors[this.colorCounter % this.userColors.length] : this.colorsadmnlvcmp[this.colorCounter],
				lineTension: 0,
				borderWidth: 4,
				borderDash: this.borderdash[this.colorCounter],
				fill: false,
				pointBackgroundColor: isUserData ? this.userColors[this.colorCounter % this.userColors.length] : this.colorsadmnlvcmp[this.colorCounter],
			})
			this.colorChange(this.chartdata.admnlvcmp)
			return val
		}else{
			let val = Object.assign(d, {
				borderColor: isUserData ? this.userColors[this.colorCounter % this.userColors.length] : this.colors[this.colorCounter],
				backgroundColor: isUserData ? this.userColors[this.colorCounter % this.userColors.length] : this.colors[this.colorCounter],
				lineTension: 0,
				borderWidth: 4,
				fill: false,
				pointBackgroundColor: isUserData ? this.userColors[this.colorCounter % this.userColors.length] : this.colors[this.colorCounter],
			})
			this.colorChange(this.chartdata.admnlvcmp)
			return val
		}
      })

      return data
    },
    lastYear() {
      return this.chartdata.labels[this.chartdata.labels.length - 1]
    }
  }
}
</script>

<style lang="scss" scoped>
canvas {
  width: 100%;
  height: 400px;
}

// Linechart Legend
.legend {
  width: 100%;
  display: flex;
  justify-content: space-around;
  .legend-child {
    display: flex;
    align-items: center;
    .legend-box {
      width: 10px;
      height: 10px;
      margin-right: 2px;
    }
    .legend-text {
      font-size: 0.75rem;
      margin-right: 2px;
    }
    img {
      cursor: pointer;
    }
  }
}
</style>
